export default "__VITE_ASSET__Cm4bjxNq__"